module.exports = __webpack_public_path__ + "static/media/talentpools-profile.ad6121b5.png";